import {
  Flex,
  FormControl,
  FormLabel,
  Icon,
  Input as ChakraInput,
  InputGroup,
  InputProps as ChakraInputProps,
  InputRightElement,
  InputLeftElement,
  Text,
  Tooltip,
} from "@chakra-ui/react";
  import { KeyboardEvent, useState } from "react";
  import { AiOutlineInfoCircle } from "react-icons/ai";
  import {
    clearMask,
    cnpj,
    cpf,

  } from "../../utils";
  
export interface InputProps extends ChakraInputProps {
  infoTooltipLabel?: string;
  infoTooltip?: boolean;
  errors?: any;
  register?: any;
  classInput?: string;
  before?: string;
  after?: string;
  label?: string;
  labelColor?: string;
  ref?: any;
  mask?: string;
  name?: string;
  variant?: string;
  displayLabel?: boolean;
  leftIcon?: any;
}
  
  const DocumentInput = ({
    infoTooltipLabel,
    infoTooltip,
    labelColor,
    label,
    children,
    className,
    classInput,
    ref,
    register,
    errors,
    before,
    after,
    type,
    mask,
    name,
    onBlur,
    displayLabel = true,
    variant = "outline",
    leftIcon,
    ...rest
  }: InputProps) => {

    const [typeInput, ] = useState(type);
  
    const handleMaskInputOnKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
      if (mask === "cpf/cnpj") {
        if (clearMask(e.currentTarget.value).length <= 13) {
          cpf(e);
        } else {
          cnpj(e);
        }
      }
    };

  

    return (
      <FormControl isInvalid={!!errors?.message}>
        {label && rest?.visibility !== "hidden" && (
          <FormLabel
            w="100%"
            gap="5px"
            display="flex"
            color={labelColor ? labelColor : "gray.400"}
            fontSize="12px"
            visibility={displayLabel ? "visible" : "hidden"}
          >
            {label}
            {infoTooltip && (
              <Tooltip h="100%" placement="top" hasArrow label={infoTooltipLabel}>
                <span>
                  <Icon w=".8rem" color="gray.400" as={AiOutlineInfoCircle} />
                </span>
              </Tooltip>
            )}
          </FormLabel>
        )}
        <Flex justify="center" align="center">
          {before && (
            <Text fontSize="2xl" color="black">
              {before}
            </Text>
          )}
          <InputGroup>
            {leftIcon && (
              <InputLeftElement pointerEvents="none" color="gray.400">
                <Icon as={leftIcon} />
              </InputLeftElement>
            )}
            <ChakraInput
              {...rest}
              {...register}
              className={classInput}
              onKeyDown={handleMaskInputOnKeyDown}
              onBlur={(e) => {
                register?.onBlur?.(e);
                onBlur?.(e);
              }}
              type={typeInput}
              name={name}
              variant={variant}
              borderRadius="2px"
              pl={leftIcon ? "2.5rem" : undefined}
            />
            {mask === "percentage" && (
               <InputRightElement  children={<Text>%</Text>} />
            )}
          </InputGroup>
  
          {after && (
            <Text fontSize="2xl" color="gray.400">
              {after}
            </Text>
          )}
        </Flex>
        {errors && (
          <Text color="danger" role="alert">
            {errors.message}
          </Text>
        )}
      </FormControl>
    );
  };
  
  export { DocumentInput };